// @flow
import HistoryLink from './HistoryLink';

export default HistoryLink;
